<template>
  <div v-if="active" class="goal" :class="{'active': active}">
    <div v-if="$config.MODE == 'SUPERLIGA'">
      <video playsinline autoplay muted class="goal__video" poster="@/assets/superliga/goal-poster.jpg" @playing="startVideo" @ended="endedVideo">
        <source v-if="animation != 'goalAnimation'" :src="getUrlAnimation() + `?v=${Math.round(Math.random() * 1000)}`" type="video/mp4"> 
        <source v-else :src="require(`@/assets/superliga/goal.mp4`) + `?v=${Math.round(Math.random() * 1000)}`" type="video/mp4">
      </video>
    </div>
    <div v-else>
      <h3>¡GOOOL!</h3>
      <img src="@/assets/inflable-success.svg" alt="Goal">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: Boolean,
    animation: String
  },
  methods: {
    getUrlAnimation() {
      return `${process.env.VUE_APP_CDN_URL_GOAL}${this.animation}`
    },
    startVideo(){
      this.$store.dispatch('soundGoalPlay')
    },
    endedVideo() {
      this.$emit('update:active', false);
      this.$store.dispatch('soundGoalStop')
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.goal {
  position: relative;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: opacity .5s ease-in-out, left .5s ease-in-out;
  opacity: 0;
  left: -100vw;

  &.active {
    opacity: 1;
    left: 0;
  }

  h3 {
    font-weight: 900;
    font-style: italic;
    color: $white;
    text-shadow: $shadow;
    font-size: 10vh;
    margin-bottom: $margin-base;
    text-align: center;
  }

  img {
    width: 50vh;
  }

  &__video {
    top: 50%;
    left: 50%;
    object-fit: cover;
    width: 100%;
    height: 100%;
    position: absolute;
    transform: translate(-50%,-50%);
    overflow: hidden;
  }
}
</style>